import React from 'react'
import _ from 'underscore'
import axios from 'axios'
import moment from 'moment'
import { ListTodo } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import {
  Card,
  CardAction,
  CardContent,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { Tabs, TabsList, TabsTrigger } from '@/components/ui/tabs'
import TasksPartial from './partial'

class Tasks extends React.Component {

  constructor(props) {
    super(props)

    this.state = {
      tasks: [],
      common_tasks: [],
      assignees: [],
      filter: 'due',
      new_task: this.getNewTaskState()
    }
  }

  componentDidMount() {
    this._mounted = true
    this.fetchTasks()
  }

  componentWillUnmount() {
    this._mounted = false
  }

  fetchTasks() {
    const params = {
      taskable_type: this.props.taskable_type,
      taskable_id: this.props.taskable_id
    }

    axios.get(`/api/sales/tasks`, {params: params})
    .then((response) => {
      if (!this._mounted) return
      this.setState({
        tasks: response.data.tasks,
        common_tasks: response.data.common_tasks,
        assignees: response.data.assignees,
        new_task: this.getNewTaskState()
      })
    }) 
    .catch((error) => {
      handleError(error)
    })
  }

  onToggleTask = (task) => {
    if (!task.actions.can_edit) {
      return
    }

    if (task.workflow_state === 'complete') {
      task.workflow_state = 'incomplete'
    }
    else {
      task.workflow_state = 'complete'
    }

    const params = {
      task: task
    }

    axios.put(`/api/sales/tasks/${task.id}`, params)
    .then((response) => {
      this.fetchTasks()
    }) 
    .catch((error) => {
      handleError(error)
    })
  }

  onCreateTask = () => {
    const task = this.state.new_task

    const params = {
      taskable_type: this.props.taskable_type,
      taskable_id: this.props.taskable_id,
      task: {
        name: task.name,
        due_at: task.due_at,
        reminder: task.reminder,
        priority: task.priority,
        workflow_state: 'incomplete',
        owner_id: task.owner_id,
        team: task.team
      }
    }

    axios.post(`/api/sales/tasks`, params)
    .then((response) => {
      this.fetchTasks()
    }) 
    .catch((error) => {
      handleError(error)
    })
  }

  getNewTaskState() {
    return {
      key: moment().format("YYYY-MM-DD HH:mm"),
      name: '',
      due_at: null,
      reminder: false,
      priority: false,
      owner: null,
      actions: {
        can_edit: true
      }
    }
  }

  onCancelNewTask = () => {
    this.setState({new_task: this.getNewTaskState()})
  }

  onUpdateTask = (task, update_params) => {
    if (!task.actions.can_edit) {
      return
    }

    task = _.extend(task, {
      name: update_params.name,
      due_at: update_params.due_at,
      reminder: update_params.reminder,
      priority: update_params.priority,
      owner_id: update_params.owner_id,
      owner: update_params.owner,
      team: update_params.team
    })

    if (!task.id) {
      this.setState({new_task: task})
      return
    }

    const params = {
      task: task
    }

    axios.put(`/api/sales/tasks/${task.id}`, params)
    .then((response) => {
      this.fetchTasks()
    }) 
    .catch((error) => {
      handleError(error)
    })
  }

  onDeleteTask = (task) => {
    if (!task.actions.can_edit) {
      return
    }

    if (!task.id) {
      return
    }

    axios.delete(`/api/sales/tasks/${task.id}`)
    .then((response) => {
      this.fetchTasks()
    }) 
    .catch((error) => {
      handleError(error)
    })
  }

  onTaskLinkClick = (url) => {
    window.open(url)
  }

  onFilter = (value) => {
    this.setState({filter: value})
  }

  renderTask(task) {
    return (
      <TasksPartial
        key={task.id || task.key}
        task={task}
        assignees={this.state.assignees}
        common_tasks={this.state.common_tasks}
        onUpdate={this.onUpdateTask}
        onDelete={this.onDeleteTask}
        onToggle={this.onToggleTask}
        onLinkClick={this.onTaskLinkClick}
        onCreate={this.onCreateTask} 
        onCancel={this.onCancelNewTask} 
      />
    )
  }

  render() {
    const completed_tasks = _.select(this.state.tasks, (task) => {
      return task.workflow_state === 'complete'
    })

    const due_tasks = _.select(this.state.tasks, (task) => {
      return task.workflow_state === 'incomplete' && task.meta.is_due
    })

    const upcoming_tasks = _.select(this.state.tasks, (task) => {
      return task.workflow_state === 'incomplete' && !task.meta.is_due
    })

    return (
      <Card className="overflow-visible">
        <CardHeader className="flex flex-wrap items-center gap-2">
          <CardTitle className="flex items-center gap-2">
            <ListTodo className="size-4" />
            Tasks
          </CardTitle>
          <CardAction className="ml-auto self-center">
            <Tabs value={this.state.filter} onValueChange={this.onFilter}>
              <TabsList className="group-data-horizontal/tabs:h-8">
                <TabsTrigger value="due">
                  Due <Badge variant="secondary">{due_tasks.length}</Badge>
                </TabsTrigger>
                <TabsTrigger value="upcoming">
                  Upcoming <Badge variant="secondary">{upcoming_tasks.length}</Badge>
                </TabsTrigger>
                <TabsTrigger value="completed">
                  Completed <Badge variant="secondary">{completed_tasks.length}</Badge>
                </TabsTrigger>
              </TabsList>
            </Tabs>
          </CardAction>
        </CardHeader>
        <CardContent className="flex flex-col gap-2">
          {this.state.filter === 'due' && _.map(due_tasks, (task) => this.renderTask(task))}
          {this.state.filter === 'upcoming' && _.map(upcoming_tasks, (task) => this.renderTask(task))}
          {this.state.filter === 'completed' && _.map(completed_tasks, (task) => this.renderTask(task))}
          {this.state.new_task && this.renderTask(this.state.new_task)}
        </CardContent>
      </Card>
    )
  }
}
    
export default Tasks